/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import {
  call,
  put,
  takeLatest,
  all,
  takeLeading,
  takeEvery,
} from "redux-saga/effects";
import * as datapipeAction from "./actions";
import * as playerActions from "../player/actions";
import {
  FetchDatapipe,
  FetchADatapipe,
  ChangeStatusDatapipe,
  CreateDatapipe,
  UpdateDatapipe,
  DeleteDatapipe,
  DeleteDatapipe_V3_1,
  HidedataPipe,
  FetchADatapipeV3,
  UpdateDatapipe_V3_1,
  CreateDatapipeV3,
  FetchAdatapipeLogs,
} from "./services";
import { getDatapipePlayerBO, getDatapipePlayerBO_v3 } from "../player/helper";
import { datapipeCustomEventBO } from "./helper";

// worker saga: makes the api call when watcher saga sees the action
export function* fetchDatapipeSaga(action) {
  try {
    const response = yield call(FetchDatapipe, action.payload);
    const datapipe =
      // eslint-disable-next-line no-nested-ternary
      response.data || {}
        ? response.data.data
        : response.data
        ? response.data
        : {};

    datapipe.list = datapipe.results;
    delete datapipe.results;
    yield put(datapipeAction.FetchDatapipeSuccess(datapipe));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(datapipeAction.FetchDatapipeFailed(error));
  }
}
export function* fetchADatapipeSaga(action) {
  try {
    const response = yield call(FetchADatapipe, action.payload);
    if (response.data && response.data.data) {
      const player = getDatapipePlayerBO(
        response?.data?.data?.collectorConfigs,
      );
      yield put(playerActions.FetchPlayerFromDatapipeSuccess(player));
      yield put(
        datapipeAction.FetchADatapipeSuccess(
          datapipeCustomEventBO(response?.data?.data),
        ),
      );
    } else {
      yield put(
        datapipeAction.FetchADatapipeFailed({
          message:
            response.data && response.data.message
              ? response.data.message
              : "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(datapipeAction.FetchADatapipeFailed(error));
  }
}
export function* fetchADatapipeV2Saga(action) {
  try {
    const response = yield call(FetchADatapipeV3, action.payload);

    if (response?.data?.success) {
      const player = getDatapipePlayerBO_v3(
        response?.data?.data?.collectorConfigs,
      );
      yield put(playerActions.FetchPlayerFromDatapipeSuccess(player));
      yield put(datapipeAction.FetchADatapipeSuccess(response?.data?.data));
    } else {
      yield put(
        datapipeAction.FetchADatapipeFailed({
          message: response?.data?.message
            ? response.data.message
            : "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // Dispatch a failure action to the store with the error
    yield put(datapipeAction.FetchADatapipeFailed(error));
  }
}
export function* changeStatusDatapipeSaga(action) {
  try {
    const response = yield call(ChangeStatusDatapipe, { ...action.payload });
    /* istanbul ignore else */
    if (response && response.data) {
      yield put(
        datapipeAction.ChangeStatusDatapipeSuccess(response.data.message),
      );
    } else {
      yield put(
        datapipeAction.ChangeStatusDatapipeFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(datapipeAction.ChangeStatusDatapipeFailed(error));
  }
}
export function* createDatapipeSaga(action) {
  try {
    const response = yield call(CreateDatapipeV3, action.payload);
    /* istanbul ignore else */
    if (response.data && response.data.success) {
      yield put(datapipeAction.CreateDatapipeSuccess("success"));
    } else {
      yield put(
        datapipeAction.CreateDatapipeFailed({
          message: response.data.message,
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(datapipeAction.CreateDatapipeFailed(error));
  }
}
export function* updateDatapipeSaga(action) {
  try {
    const response = yield call(UpdateDatapipe_V3_1, action.payload);
    /* istanbul ignore else */
    if (response.data && response.data.success) {
      yield put(datapipeAction.UpdateDatapipeSuccess("success"));
    } else {
      yield put(
        datapipeAction.UpdateDatapipeFailed({
          message: response.data.message,
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(datapipeAction.UpdateDatapipeFailed(error));
  }
}
export function* fetchADatapipeDelSaga(action) {
  try {
    const response = yield call(FetchADatapipeV3, action.payload);
    yield put(
      response.data && response.data.data
        ? datapipeAction.FetchADatapipeDelSuccess(response.data.data)
        : datapipeAction.FetchADatapipeDelFailed({
            message:
              response.data && response.data.message
                ? response.data.message
                : "Something went wrong. Please try later",
          }),
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(datapipeAction.FetchADatapipeDelFailed(error));
  }
}
export function* deleteDatapipeSaga(action) {
  try {
    const response = yield call(DeleteDatapipe_V3_1, action.payload);
    if (response.data) {
      yield put(datapipeAction.DeleteDatapipeSuccess(response.data));
    } else {
      yield put(
        datapipeAction.DeleteDatapipeFailed({
          message:
            response.data && response.data.message
              ? response.data.message
              : "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    yield put(datapipeAction.DeleteDatapipeFailed(error));
  }
}

export function* loadMoreDatapipeSaga(action) {
  const { payload } = action;
  try {
    const response = yield call(FetchDatapipe, payload);
    yield put(
      datapipeAction.LoadMoreDatapipeSuccess(response.data.data.results),
    );
  } catch (error) {
    yield put(datapipeAction.LoadMoreDatapipeFailed(error));
  }
}

export function* hideDatapipeSaga(action) {
  try {
    const response = yield call(HidedataPipe, action.payload);
    /* istanbul ignore if */
    if (response.data.data.datapipeId && response.data.success) {
      yield put(datapipeAction.HideDatapipeSuccess(action.payload));
      /* istanbul ignore next */
    } else {
      yield put(datapipeAction.HideDatapipeFailed(response.data));
    }
    /* istanbul ignore next */
  } catch (error) {
    yield put(datapipeAction.HideDatapipeFailed(error));
  }
}

export function* FetchADatapipeLogsSaga(action) {
  try {
    const response = yield call(FetchAdatapipeLogs, action.payload);
    if (response && response.data && response.data.success) {
      yield put(datapipeAction.FetchADatapipeLogsSuccess(response?.data));
    } else {
      yield put(datapipeAction.FetchDatapipeLogsFailed(response.data));
    }
  } catch (error) {
    yield put(datapipeAction.FetchDatapipeLogsFailed(error));
  }
}

// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* datapipeWatcher() {
  yield all([
    takeLatest(datapipeAction.types.FETCH_DATAPIPE, fetchDatapipeSaga),
    takeEvery(datapipeAction.types.LOAD_MORE_DATAPIPE, loadMoreDatapipeSaga),
    takeLatest(datapipeAction.types.FETCH_A_DATAPIPE, fetchADatapipeV2Saga),
    takeLatest(
      datapipeAction.types.CHANGE_STATUS_DATAPIPE,
      changeStatusDatapipeSaga,
    ),
    takeLeading(datapipeAction.types.CREATE_DATAPIPE, createDatapipeSaga),
    takeLeading(datapipeAction.types.UPDATE_DATAPIPE, updateDatapipeSaga),
    takeLatest(
      datapipeAction.types.FETCH_A_DATAPIPE_DEL,
      fetchADatapipeDelSaga,
    ),
    takeLeading(datapipeAction.types.DELETE_DATAPIPE, deleteDatapipeSaga),
    takeLatest(datapipeAction.types.HIDE_DATAPIPE, hideDatapipeSaga),
    takeLatest(
      datapipeAction.types.FETCH_A_DATAPIPE_LOGS,
      FetchADatapipeLogsSaga,
    ),
  ]);
}
